import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "Information we collect",
    body: [
      "We may collect your name, email, phone number, course interest, enquiry type, and learning preferences when you submit forms, create an account, or contact QA Coder.",
      "We also collect basic analytics events such as page views, search activity, CTA clicks, and course interest to improve the learning experience.",
    ],
  },
  {
    title: "How we use information",
    body: [
      "We use your information to respond to enquiries, book demo classes, provide course guidance, improve website content, and manage learning or admin workflows.",
      "We do not sell learner information. Access is limited to support, training, and admin needs.",
    ],
  },
  {
    title: "Data storage",
    body: [
      "QA Coder uses Firebase Authentication and Firestore for account, enquiry, and analytics storage.",
      "You can contact us to request correction or removal of your personal information where applicable.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <PolicyPageLayout
      eyebrow="Privacy"
      title="Privacy Policy"
      description="How QA Coder collects, stores, and uses learner and enquiry information."
      sections={sections}
    />
  );
}
